export default {"src":"/_next/static/media/mitsubi.045ec6cf.svg","height":123,"width":326,"blurWidth":0,"blurHeight":0};